import { useState, useCallback } from 'react';
import { pharmacyService } from '@/services/pharmacy';
import { Pharmacy } from '@/types';

export function usePharmacies() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const setActivePharmacyById = useCallback(async (pharmacyId: string): Promise<boolean> => {
    setLoading(true);
    setError(null);
    
    try {
      await pharmacyService.setActivePharmacy(pharmacyId);
      return true;
    } catch (err: any) {
      const errorMessage = err.response?.data?.error || 'Failed to set active pharmacy';
      setError(errorMessage);
      console.error('Error setting active pharmacy:', err);
      return false;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    setActivePharmacyById,
    loading,
    error,
  };
}
